import { render } from "./CPOAdminDashboard.vue?vue&type=template&id=5bb8fb00"
import script from "./CPOAdminDashboard.vue?vue&type=script&lang=js"
export * from "./CPOAdminDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__